
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/image-cropper",
      function () {
        return require("private-next-pages/image-cropper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/image-cropper"])
      });
    }
  